import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'designations/'

const initialState = {
    designations: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getDesignations = createAsyncThunk('desig/gad', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleDesignation = createAsyncThunk('desig/gsd', async (unitID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${unitID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addDesignation = createAsyncThunk('desig/ad', async (deptData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editDesignation = createAsyncThunk('desig/ed', async (deptData, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}${deptData.desigID}`, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteDesignation = createAsyncThunk('desig/dd', async (deptID, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}${deptID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const designationSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.units = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDesignations.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDesignations.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.designations = action.payload
            })
            .addCase(getDesignations.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.designations = []
            })
    }
})

export const { reset } = designationSlice.actions

export default designationSlice.reducer